module.exports = __webpack_public_path__ + "static/media/FJ.22516a81.png";